import type { CybusConnection } from '../../../domain'

import { useTranslator } from '../Internationalization'

export const useConnectionHostTranslator = (): (connection: CybusConnection) => string | null => {
    const translator = useTranslator()
    return (c) => c.ipAddress || (c.brokers && translator.formatList(c.brokers)) || c.host
}

export const useConnectionPortTranslator = (): (connection: CybusConnection) => string | null => {
    return (c) => c.cncType || c.device || c.port
}
